export enum DeviceType {
  ios = 1,
  android = 2,
  web = 3,
}
